module.exports = __webpack_public_path__ + "media/add/off-80-a93e1333.png";